/* Otzera gemstone guides (sections/otzera-guide-*.liquid). Plain ES5. 22 Oct 2026.
 *  - Contents: builds "In this guide" from the article's H2s and highlights the one being read.
 *  - Image guard: an article image that fails to load is hidden (with its figure) instead of
 *    showing a broken-image icon, and logged to the console so it can be found and replaced.
 *  - Phone buy bar: shows once the reader is past the hero, hides when the stone grid or the
 *    footer is on screen.
 */
(function () {
  'use strict';
  if (window.__otzGuide) { return; }
  window.__otzGuide = true;

  function slug(text, used) {
    var base = String(text).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section';
    var s = base;
    var i = 2;
    while (used[s] || document.getElementById(s)) { s = base + '-' + i; i++; }
    used[s] = true;
    return s;
  }

  function guardImages(body) {
    function hide(img) {
      var fig = img.closest('figure');
      var pair = img.closest('.otzg-pair');
      (pair && pair.querySelectorAll('img').length < 2 ? pair : fig || img).style.display = 'none';
      if (window.console) { console.warn('[Otzera guide] image failed to load and was hidden:', img.currentSrc || img.src); }
    }
    var imgs = body.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        if (img.complete && img.naturalWidth === 0 && img.getAttribute('src')) { hide(img); return; }
        img.addEventListener('error', function () { hide(img); });
      })(imgs[i]);
    }
  }

  function buildToc(root, body) {
    var list = root.querySelector('[data-otzg-toc]');
    if (!list) { return; }
    var heads = body.querySelectorAll(':scope > h2');
    if (heads.length < 2) { return; }
    var used = {};
    var links = [];
    for (var i = 0; i < heads.length; i++) {
      var h = heads[i];
      if (!h.id) { h.id = slug(h.textContent, used); }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
      links.push(a);
    }
    var nav = list.closest('.otzg-toc');
    var toggle = root.querySelector('[data-otzg-toc-toggle]');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = !nav.classList.contains('is-open');
        nav.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      list.addEventListener('click', function (e) {
        if (e.target.closest('a') && getComputedStyle(toggle).display !== 'none') {
          nav.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }
    // Highlight the last heading above 30% of the viewport. Listens in the capture phase so it
    // also hears the theme's own scrolling wrapper, not just the window.
    var current = null;
    var queued = false;
    function spy() {
      queued = false;
      var line = window.innerHeight * 0.3;
      var id = null;
      for (var k = 0; k < heads.length; k++) {
        if (heads[k].getBoundingClientRect().top <= line) { id = heads[k].id; } else { break; }
      }
      if (id === current) { return; }
      current = id;
      links.forEach(function (a) {
        var on = a.getAttribute('href') === '#' + current;
        a.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && list.scrollHeight > list.clientHeight) {
          var top = a.offsetTop;
          if (top < list.scrollTop || top + a.offsetHeight > list.scrollTop + list.clientHeight) {
            list.scrollTop = top - list.clientHeight / 2;
          }
        }
      });
    }
    document.addEventListener('scroll', function () {
      if (!queued) { queued = true; window.requestAnimationFrame(spy); }
    }, { capture: true, passive: true });
    spy();
  }

  function buyBar(root) {
    var bar = root.querySelector('[data-otzg-bar]');
    if (!bar || !('IntersectionObserver' in window)) { return; }
    var hero = document.querySelector('.otzg-hero');
    var ends = document.querySelectorAll('[data-otzg-end], footer');
    var pastHero = false;
    var atEnd = false;
    function sync() { bar.classList.toggle('is-on', pastHero && !atEnd); }
    if (hero) {
      new IntersectionObserver(function (e) { pastHero = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; sync(); }).observe(hero);
    } else { pastHero = true; }
    var onScreen = [];
    var endIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var k = onScreen.indexOf(e.target);
        if (e.isIntersecting && k < 0) { onScreen.push(e.target); }
        if (!e.isIntersecting && k > -1) { onScreen.splice(k, 1); }
      });
      atEnd = onScreen.length > 0;
      sync();
    });
    for (var i = 0; i < ends.length; i++) { endIo.observe(ends[i]); }
  }

  function init() {
    var roots = document.querySelectorAll('[data-otzg]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (root.getAttribute('data-otzg-bound') === '1') { continue; }
      root.setAttribute('data-otzg-bound', '1');
      var body = root.querySelector('[data-otzg-body]');
      if (body) { guardImages(body); buildToc(root, body); }
      buyBar(root);
    }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();